import type { AnomalyDetection } from './usageEventAnalysis';

const MAX_CARDS = 10;

export function AnomalyHeadsUpPanel({ anomalies }: { anomalies: AnomalyDetection[] }) {
  if (anomalies.length === 0) return null;
  const visible = anomalies.slice(0, MAX_CARDS);
  const overflow = anomalies.length - visible.length;

  return (
    <section aria-label="Anomaly heads-up" className="px-6 pt-2 pb-4">
      <h2 className="text-xs uppercase tracking-wide text-hbs-text-mute mb-2">
        ⚠ Heads up — {anomalies.length} {anomalies.length === 1 ? 'anomaly' : 'anomalies'} this week
      </h2>
      <div className="space-y-2">
        {visible.map((a) => (
          <article
            key={a.event.id}
            role="alert"
            aria-label={`Anomaly: ${a.headline}`}
            className="bg-anomaly border-l-[3px] border-anomaly-border rounded px-3 py-2"
          >
            <div className="text-sm font-medium text-hbs-text">{a.headline}</div>
            <div className="text-xs text-hbs-text-mute mt-0.5">{a.subline}</div>
          </article>
        ))}
        {overflow > 0 && (
          <div className="text-xs text-hbs-text-mute pt-1">+ {overflow} more anomalies</div>
        )}
      </div>
    </section>
  );
}
